import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n"; // Import de la configuration i18n
import useInitScripts from "./hooks/useInitScripts";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About2 from "./components/About2";
import PhraseAccroche from "./components/PhraseAccroche";
import InfiniteElement from "./components/InfiniteElement";
import Resume2 from "./components/Resume2";
import Services from "./components/Services";
import Certifications from "./components/Certifications";
import FAQ from "./components/FAQ";
import Carousel from "./components/Carousel";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";
import Preloader from "./components/Preloader";
import "./assets/css/main.css";

function App() {
  useInitScripts(); // Initialisation des scripts au montage du composant
  const { i18n } = useTranslation(); // Récupération de la fonction de changement de langue
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.setItem("language", lng); // Sauvegarde de la langue choisie
  };


  return (
    <>
      {/* <Maintenance />  */}
      <Preloader />
      <div className="App">
        <Header changeLanguage={changeLanguage} language={language} />
        <Hero />
        {/*<About />*/}
        <About2 />
        <PhraseAccroche />
        <InfiniteElement />
        {/*<Resume />*/}
        <Resume2 />
        <Services />
        {/*<Stats />*/}
        {/*<Stats2 />*/}
        <Certifications />
        {/*<Portfolio />*/}
        <FAQ />
        <Carousel />
        <Testimonials />
        <Contact />
        <Footer />
        <ScrollTop />
      </div>
    </>
  );
}

export default App;
